const initialState = {
  listingRows: [],
  setFocusGroup: {},
  deleteGroupSnackOpen: false,
  deletedGroupName: '',
  badGroups: [],
};

function groups(state = initialState, action) {
  switch (action.type) {
    case 'SET_LISTINGS_ROWS':
      return { ...state, listingRows: action.payload };
    case 'SET_FOCUS_GROUP':
      return { ...state, setFocusGroup: action.payload };
    case 'SET_DELETE_GROUP_MODAL_OPEN':
      return { ...state, deleteGroupSnackOpen: action.payload };
    case 'SET_DELETE_GROUP_NAME':
      return { ...state, deletedGroupName: action.payload };
    case 'SET_BAD_GROUPS':
      return { ...state, badGroups: action.payload };
    default:
      return state;
  }
}

export default groups;
